<mat-form-field *ngIf="to['multiple']; else singleSelect" class="form-element">
    <!-- <mat-label *ngIf="to.label">{{ to.label | translate }}</mat-label> -->
    <mat-select placeholder="{{to.label}}"  [formControl]="formControl" [formlyAttributes]="field" #choosedValue
        [multiple]="to['multiple']" (valueChange)="change(field.key, field.id, choosedValue.value)">
        <ng-container *ngFor="let item of to.options">
            <mat-option [value]="item.label" [disabled]="item.disabled">
                {{item.label}}
            </mat-option>
        </ng-container>
    </mat-select>
</mat-form-field>

<ng-template #singleSelect>
    <mat-form-field class="form-element">
        <mat-select placeholder="{{to.label}}" [formControl]="formControl" [formlyAttributes]="field" #choosedValue (valueChange)="change(field.key, field.id, choosedValue.value)">
            <ng-container *ngFor="let item of to.options">
                <mat-option [value]="item.label" [disabled]="item.disabled">
                    {{item.label}}
                </mat-option>
            </ng-container>
        </mat-select>
    </mat-form-field>
</ng-template>